// import {modal, contextMenu} from "@mc/shared";
import { reducer as toastr } from 'react-redux-toastr';
import { reducer as form } from 'redux-form';
import { default as app } from './app';

// TODO domyslet full override reducers
let reducers = undefined as any;
try {
    reducers = require('../../../../src/reducers').default as any as object;
} catch (e) {
    reducers = {};
}

/**
 * Definice základních store
 */
export default {
    // modalDialog: modal.ModalReducer,
    // contextMenu: contextMenu.reducer,
    toastr,
    form,
    app,
    ...reducers,
};
